import { html, LitElement } from 'lit';

export default class PrizeWebComponent extends LitElement {
  createRenderRoot() {
    return this;
  }

  static properties = {
    name: { type: String },
    data: { type: Object },
    basepath: { type: String },
    program_id: { type: String }
  };

  constructor() {
    super();
    this.name = 'Prize Web Component';
    this.data = {};
    this.dataStatic = [
      {
        text: 'Wafer sweet apple pie gummi bears muffin. Pie cookie brownie marzipan candy.'
      },
      {
        text: 'Wafer sweet apple pie gummi bears muffin. Pie cookie brownie marzipan candy.'
      },
      {
        text: 'Macaroon marzipan tart danish tiramisu tootsie roll donut cupcake fruitcake. '
      }
    ];
    this.basepath = '';
    this.program_id = '';
  }

  async connectedCallback() {
    super.connectedCallback();

    // console.log(this.data, 'BUENAS BUENAS');
  }

  render() {
    const { data, basepath, program_id } = this;

    const { prize_detail, subtitleprize, titleprize, bullet } = data;

    const newUrl = String(bullet.url).replace('/uploads/', '') || '';

    let dataItemsPrize;

    if (prize_detail.length ?? 0) {
      dataItemsPrize = html`
        ${prize_detail.map(
    (item) => html`
            <div class="items-prizes" aria-label="Prizes list">
              <img
                class="icon"
                src="${basepath}/dist/${program_id}/img/${newUrl}"
                alt="Prize bullet"
              />
              <div>
                ${item?.prize_content[0].children?.map(
    (child) => html` <span class="info">${child.text}</span> `
  ) || ''}
              </div>
            </div>
          `
  ) || ''}
      `;
    } else {
      dataItemsPrize = html`
        ${this.dataStatic?.map(
    (item) => html`
            <div>
              <!-- <img class="icon" src="/img/icondeadpool.png"> -->
              <div class="circle"></div>
              <span class="info">${item.text}</span>
            </div>
          `
  ) || ''}
      `;
    }

    return html`
      <section class="prize-component">
        <h2>${titleprize || 'Prize Title'}</h2>

        <div class="prize-component_subtitle">
          ${subtitleprize[0].children[0].text !== ''
    ? subtitleprize?.map((item) => html` <p>${item?.children[0].text}</p> `)
    : html` <p>Prize Subtitle</p> `}
        </div>

        <div class="prize-component_details">${dataItemsPrize}</div>
      </section>
    `;
  }
}

customElements.define('prize-webcomponent', PrizeWebComponent);
